import Item from './item';
import Slider from './slider';
import open from './open';
import './styles/index.scss';
const ExpandedSlider = Slider;
ExpandedSlider.Item = Item;
ExpandedSlider.show = open;
export default ExpandedSlider;
